module.exports = __webpack_public_path__ + "img/Hardware.f95ded6d.png";